<section id="productsPage" class="mb-28">
  <div class="relative pb-8 mx-auto max-w-screen-2xl">
    <div class="w-10/12 pb-10 mx-auto sm:w-9/12">
      <h1 class="pt-10 bg-white lg:text-center">
        {{ "products_page.title" | translate }}
      </h1>
      <p class="max-w-2xl pt-4 mx-auto lg:text-center">
        {{ "products_page.subtitle" | translate }}
      </p>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 w-10/12 mx-auto sm:w-9/12">
      @for (product of products; track product.productId) {
        <div
          class="z-10 pygProduct"
          (click)="toElement(product.productFragment)"
        >
          <div class="flex items-center justify-between w-full">
            <div class="flex pr-0.5 sm:pr-3">
              <img
                src="assets/img/Products/ProductIcons/{{
                  product.productFavicon
                }}"
                alt="Image"
                class="w-12 sm:w-auto"
              />
              <div class="pl-3 my-auto sm:pl-6 sm:py-2">
                <h4 class="text-lg sm:text-xl pygLineHeight">
                  {{ product.productName | translate }}
                </h4>
                <span>{{ product.productHeading | translate }}</span>
              </div>
            </div>
            <div>
              <div
                class="flex items-center justify-center rounded-full w-9 h-9 sm:w-12 sm:h-12 pygColor"
              >
                <img
                  src="assets/img/Products/ProductIcons/arrow-down.svg"
                  alt="Arrow"
                  class="h-6 arrow1"
                />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>
